import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { Store } from '@sama/app-state';
import { getOutputHelper } from '../../../shared/output-helpers/get-output-helper';
import { ContextMenuOption } from '../../../team-apis/content/content-connector';
import { AbstractOutputWithAnswerOptions } from '../../../team-apis/otterdam/outputs/output';
import { OutputInfo, outputInfoStoreToken } from '../../h3ml/state/output-info';

@Component({
  selector: 'h3-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContextMenuComponent {
  @ViewChild('contextMenu')
  private contextMenu?: MatMenuTrigger;
  @ViewChild('menu')
  private menuElement?: MatMenu;
  menuOptions: ContextMenuOption[] = [];
  position = [0, 0];

  constructor(
    @Inject(outputInfoStoreToken)
    private outputInfoStore: Store<OutputInfo<AbstractOutputWithAnswerOptions>>,
  ) {}

  openContextMenu() {
    this.contextMenu!.openMenu();
    this.setMouseFocus();
  }

  closeContextMenu() {
    this.contextMenu?.closeMenu();
  }

  refocusOutput() {
    const output = this.outputInfoStore.state().output;
    const el = getOutputHelper(output.type).getFocusableOutput(
      output.name,
      document,
    );
    el?.focus({ preventScroll: true });
  }

  private setMouseFocus() {
    // By default, the focus origin is set to 'program' and it does
    // not have the same styling. Origin 'program' will highlight the
    // first element.
    this.menuElement?.focusFirstItem('mouse');
  }
}
